import React from 'react';
import PropTypes from 'prop-types';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles((theme) => ({
  headCell: {
    fontWeight: 'bold',
  },
  cellGrid: {
    display: 'flex',
    flexDirection: 'column'
  }
}));

const tableCellStyle = {
  height: '100%',
  fontWeight: 'bold',
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  fontSize: '14px',
  lineHeight: '24px'
};

const TableHeader = (props) => {
  const classes = useStyles();

  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <Table>
      <TableHead>
        <TableRow>
          {props.columns.map((column) => (
            <TableCell
              key={column.id}
              align={column.align || 'left'}
              sortDirection={orderBy === column.id ? order : false}
              classes={{ head: classes.headCell }}
              style={{...tableCellStyle, ...column.headerStyle}}
            >
              <TableSortLabel
                active={orderBy === column.id}
                direction={orderBy === column.id ? order : 'asc'}
                onClick={column.sortable ? createSortHandler(column.id) : null}
                hideSortIcon={!column.sortable}
              >
                {column.label}
              </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    </Table>
  );
};

TableHeader.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object),
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string,
  rowCount: PropTypes.number.isRequired,
};

export default TableHeader;
